import React from 'react'

const FooterEnd = () => {
  return (
    <div className='w-full py-10'>
        <p className='text-center text-gray-500 text-base'>
              &#169;2023. All rights reserved by Maxon Gomeka 
        </p>
        </div>
  )
}

export default FooterEnd